import React from 'react';
import { Label } from '../../../components/ui/label';
import { MoneyInput } from '../../../components/MoneyInput';

export default function AnnualTaxesStep({ formData, updateFormData }) {
  return (
    <div data-testid="taxes-step">
      <h2 className="text-2xl font-bold text-[#0f172a] mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
        Annual Taxes
      </h2>
      <div className="space-y-6">
        <div>
          <Label htmlFor="federalTaxes">Federal Income Taxes</Label>
          <MoneyInput value={formData.federalTaxes} onChange={(v) => updateFormData({ federalTaxes: v })} placeholder="$0" className="mt-2" testId="federal-taxes-input" />
        </div>
        <div>
          <Label htmlFor="stateTaxes">State Income Taxes</Label>
          <MoneyInput value={formData.stateTaxes} onChange={(v) => updateFormData({ stateTaxes: v })} placeholder="$0" className="mt-2" testId="state-taxes-input" />
        </div>
        <div>
          <Label htmlFor="fica">FICA</Label>
          <MoneyInput value={formData.fica} onChange={(v) => updateFormData({ fica: v })} placeholder="$0" className="mt-2" testId="fica-input" />
        </div>
        <div>
          <Label htmlFor="realEstateTaxes">Real Estate Taxes</Label>
          <MoneyInput value={formData.realEstateTaxes} onChange={(v) => updateFormData({ realEstateTaxes: v })} placeholder="$0" className="mt-2" testId="real-estate-taxes-input" />
        </div>
        <div>
          <Label htmlFor="otherTaxes">Other Taxes</Label>
          <MoneyInput value={formData.otherTaxes} onChange={(v) => updateFormData({ otherTaxes: v })} placeholder="$0" className="mt-2" testId="other-taxes-input" />
        </div>
      </div>
    </div>
  );
}
